import {PublicKey} from '@solana/web3.js';
import {getAssociatedTokenAddressSync} from '@solana/spl-token';
import {getSolanaTokenProgramId} from 'src/utils/getSolanaTokenProgramId';

export const getSourceTokenAccountAddress = (
  currencyContractAddress: string,
  sourceAddress: string,
  currency: string,
): PublicKey => {
  const sourceAddressPublicKey = new PublicKey(sourceAddress);
  const token = new PublicKey(currencyContractAddress);
  const programId = getSolanaTokenProgramId(currency);
  return getAssociatedTokenAddressSync(
    token,
    sourceAddressPublicKey,
    false,
    programId,
  );
};
